import type { CanvasObject } from '../types';

/**
 * 블렌드 모드 타입 정의
 */
export type BlendMode = CanvasObject['blendMode'];

/**
 * Canvas 2D의 GlobalCompositeOperation 타입
 */
export type GlobalCompositeOperation =
  | 'source-over'
  | 'source-in'
  | 'source-out'
  | 'source-atop'
  | 'destination-over'
  | 'destination-in'
  | 'destination-out'
  | 'destination-atop'
  | 'lighter'
  | 'copy'
  | 'xor'
  | 'multiply'
  | 'screen'
  | 'overlay'
  | 'darken'
  | 'lighten'
  | 'color-dodge'
  | 'color-burn'
  | 'hard-light'
  | 'soft-light'
  | 'difference'
  | 'exclusion'
  | 'hue'
  | 'saturation'
  | 'color'
  | 'luminosity';

/**
 * 블렌드 모드를 Canvas의 globalCompositeOperation 값으로 변환
 * @param blendMode 블렌드 모드 값
 * @returns Canvas의 globalCompositeOperation 값 또는 null (normal일 때)
 */
export function getBlendModeOperation(
  blendMode: BlendMode
): GlobalCompositeOperation | null {
  if (!blendMode || blendMode === 'normal') {
    return null; // 성능 최적화: normal일 때는 null 반환하여 조건부 처리 가능
  }
  
  // plus-lighter는 Canvas 2D에서 lighter로 변환
  if (blendMode === 'plus-lighter') {
    return 'lighter';
  }
  
  return blendMode as GlobalCompositeOperation;
}

/**
 * 객체에 블렌드 모드가 설정되어 있는지 확인
 * @param obj CanvasObject
 * @returns 블렌드 모드가 설정되어 있고 normal이 아닌지 여부
 */
export function hasBlendMode(obj: CanvasObject): boolean {
  return !!(obj.blendMode && obj.blendMode !== 'normal');
}

